import z from "zod";

export const FileInfoDetailsSchema = z.object({
  id: z.uuid().optional(),
  key: z.string(),
  name: z.string(),
  lastModified: z.coerce.date().optional(),
  size: z.number().optional(),
  mimetype: z.string(),
  url: z.string(),
  uploadedAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});
export type FileInfoDetailsDto = z.infer<typeof FileInfoDetailsSchema>;

export const CMS_FILE_STORAGE = {
  /**
   * The Tokens storage is used to store token icons. In this file storage, the filename is used to identify the token and should be used by the front-end to forge the token icon URL. (example: BTC -> https://cdn.cede.com/tokens/btc.svg)
   */
  TOKENS: "tokens",
  /**
   * The Media storage is used to store any other media files. In this file storage, the filename is not used to identify the file and the system will always prepend the filename with a
   * random UUID to ensure uniqueness. (example: logo.png -> 123e4567-e89b-12d3-a456-426614174000-logo.png)
   * The front-end should use the URL provided by the backend to display the media file.
   */
  MEDIA: "media",
} as const;

export type CmsFileStorage = (typeof CMS_FILE_STORAGE)[keyof typeof CMS_FILE_STORAGE];

export const ListFilesResultSchema = z.object({
  files: z.array(FileInfoDetailsSchema),
  totalCount: z.number(),
});

export type ListFilesResultDto = z.infer<typeof ListFilesResultSchema>;

export const UploadFileResponseSchema = z.object({
  key: z.string(),
});
export type UploadFileResponse = z.infer<typeof UploadFileResponseSchema>;
